import { Flex } from "@/kit/antipad-ui/Flex"
import { FC } from "react";
import styles from './styles.module.css';
interface TagProps {
    children?: React.ReactNode;
}
export const Tag: FC<TagProps> = ({ children }) => {
    return <Flex className={styles.tag}  align="center" justify="center" >
        {children}
    </Flex>
}